import React from 'react';
import BaseComponent from '../../BaseComponent';
import {Bar} from 'react-chartjs-2';
import {Button, Card, CardBody, CardHeader, Col, Label, ListGroup, ListGroupItem, Row} from 'reactstrap';
import {MdRefresh} from 'react-icons/md';
import {getColor} from 'utils/colors';
import DateInput from '../../Widget/DateInput';
import CircularProgress from '@material-ui/core/CircularProgress';
import Global from '../../../utils/Global';
import {parseDate} from '../../../utils/Utilities';
import {ModelCategoryDto} from '../../../model/model';
// import label from '../../../message/Label'
import label from 'enqc-utilities/src/label/Label'
import PrimaryCardHeader from "../../Widget/PrimaryCardHeader";


let report ={
    bar: {
        data: {
            labels: label.MONTHS_LABEL,
            datasets: [
                {
                    label: label.Success,
                    backgroundColor: '#6a82fb',
                    stack: 'Expense',
                    data: [10000, 30000, 50000, 80000, 60000, 20000, 10000, 10000,10000,10000,10000,10000],
                },
                {
                    label: label.Failed,
                    backgroundColor: '#fc5c7d',
                    stack: 'Expense',
                    data: [30000, 80000, 50000, 100000, 60000, 40000, 90000, 20000,20000,20000,20000,20000],
                },
            ],
        },
        options: {
            title: {
                display: true,
                text: label.ModelCategory,
            },
            tooltips: {
                mode: 'index',
                intersect: true,
            },
            hover: {
                mode: 'index',
            },
            responsive: true,
            legend: {
                display: true,
            },
            scales: {
                xAxes: [
                    {
                        stacked: true,
                        display: true,
                    },
                ],
                yAxes: [
                    {
                        stacked: true,
                        display: true,
                    },
                ],
            },
        },
    }
}

let firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
let firstDayOfYear = new Date(new Date().getFullYear(), 0, 1)

export default class DashboardCategoryAnalytic extends BaseComponent{

    constructor(props) {
        super(props);
        let state = this.state
        state.modelCategories = new Array()
        state.startDate = parseDate(firstDayOfYear, "yyyy-mm-dd")
        state.endDate = parseDate(new Date(), "yyyy-mm-dd");
        state.analytic = {}
        state.modelCategory = new ModelCategoryDto()
        this.setState(state)

    }

    componentDidMount() {
        super.componentDidMount();
        this.fetchCategoryAnalytic()
    }

    fetchCategoryAnalytic=()=>{
        let fetching = this.state.fetching
        this.setState({
            fetching:true
        }, () => {
            this.get(Global.API.DASHBOARD_CATEGORY_ANALYTIC, {
                params:{
                    startDate : this.state.startDate,
                    endDate : this.state.endDate,
                    dataId : this.state.modelCategory.id,
                }
            }, null, response=>{
                this.setState({fetching:false})
                if(response.code===200){
                    this.setState({
                        analytic:response.data
                    })
                }
            })
        })

    }


    render() {
        const primaryColor = getColor('primary');

        let modelCategories = this.state.modelCategories
        let analytic = this.state.analytic
        let fetching = this.state.fetching
        let cartData = {
            labels:[],
            datasets:[]
        }

        if(analytic.barInfos){
            analytic.barInfos.map((item, index)=>(
                cartData.labels.push(item.label)
            ))
        }

        if(analytic.datasets){
            analytic.datasets.map((item, index)=>{
                cartData.datasets.push(item)
            })
        }

        return (
            <Card>
                <PrimaryCardHeader
                    content={(
                        <Row>
                            <Col className="mb-0 p-2">
                                {label.Category}
                            </Col>
                        </Row>
                    )}/>
                <ListGroup flush>
                    <ListGroupItem>
                        <Row>
                            <Col md={5}>
                                <Label for="startDate">{label.StartDate}</Label>
                                <DateInput
                                    id="startDate"
                                    maxdate={this.state.endDate}
                                    value={this.state.startDate}
                                    onChange={(e) =>{
                                        let value = e.target.value
                                        this.setState({
                                            startDate : value?value:firstDayOfMonth
                                        }, () => {

                                        })
                                    }}
                                    placeholder={label.StartDate}
                                />
                            </Col>
                            <Col md={5}>
                                <Label for="endDate">{label.EndDate}</Label>
                                <DateInput
                                    id="endDate"
                                    mindate={this.state.startDate}
                                    value={this.state.endDate}
                                    onChange={(e) =>{
                                        let value = e.target.value
                                        this.setState({
                                            endDate : value?value:parseDate(new Date(), "yyyy-mm-dd")
                                        }, () => {

                                        })
                                    }}
                                    placeholder={label.EndDate}
                                />
                            </Col>
                            {
                                (fetching)?(
                                    <Col md={2}>
                                        <CircularProgress style={{marginTop:'32px'}}  color="secondary" size={24}/>
                                    </Col>
                                ):(
                                    <Col md={2}>
                                        <Button style={{marginTop:'32px'}} className="float-right" onClick={event=>{
                                            this.fetchCategoryAnalytic()
                                        }}><MdRefresh/></Button>
                                    </Col>
                                )
                            }
                        </Row>
                    </ListGroupItem>
                </ListGroup>
                <CardBody>
                    <Bar data={cartData} options={report.bar.options} />
                </CardBody>
            </Card>
        );
    }


}
